import {
  Box,
  Stack,
  TextField,
  Typography,
  FormHelperText,
} from '@mui/material';
import React from 'react';

interface FullNameTextFieldProps {
  error: boolean;
  helperText: string | undefined;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
  userRole: string;
}

const RoleTextField = ({
  error,
  helperText,
  onChange,
  userRole,
  onBlur,
}: FullNameTextFieldProps) => {
  return (
    <Box sx={{ width: '100%' }}>
      <Stack
        direction='column'
        justifyContent='flex-start'
        alignItems='flex-start'
      >
        <Typography
          variant='caption'
          sx={{
            fontFamily: 'Schibsted Grotesk',
            fontSize: '0.875rem',
            fontWeight: 500,
            lineHeight: '1.0625rem',
            letterSpacing: '0em',
            textAlign: 'left',
            marginBottom: 1.2,
          }}
        >
          Role
        </Typography>
        <TextField
          hiddenLabel
          fullWidth
          id='outlined-search'
          placeholder='Enter Full Name'
          type='text'
          error={error}
          onChange={onChange}
          value='External User'
          name='fullName'
          onBlur={onBlur}
          variant='filled'
          sx={{
            ...{
              '& .MuiFilledInput-root:after': {
                border: 'none',
              },
              '& .Mui-focused': {
                border: 'none',
              },
              '& .MuiFilledInput-input': {
                height: '1.5rem',
                fontWeight: 400,
                fontFamily: 'Schibsted Grotesk',
                fontSize: '14px',
              },
              '& .MuiFilledInput-root': {
                borderRadius: '6px',
              },
              '& .MuiFilledInput-root:before': {
                borderBottom: 'none',
              },
              pb: '0.5rem',
              '& .MuiFilledInput-root:hover:not(.Mui-disabled,.Mui-error):before':
                {
                  borderBottom: 'none',
                },
            },
            ...(!userRole && {
              '& .MuiInputLabel-root': {
                color: '#0000004D',
              },
              '& .MuiFormLabel-root': {
                fontFamily: 'Schibsted Grotesk',
                fontSize: '14px',
                fontWeight: 400,
                lineHeight: '17.28px',
                color: '#0000004D',
                left: '0.1rem',
                top: '0.3rem',
              },
            }),
            ...(userRole && {
              '& .MuiFilledInput-root': {
                backgroundColor: 'rgba(0, 0, 0, 0.01)',
                borderRadius: '6px',
              },
              '& .MuiFilledInput-input': {
                border: '1px solid rgba(0, 0, 0, 0.50)',
                borderRadius: '6px',
              },
              '& .MuiFormLabel-root': {
                fontFamily: 'Schibsted Grotesk',
                fontSize: '12px',
                letterSpacing: '0em',
                textAlign: 'left',
                left: '.15rem',
                color: '#000000',
              },
            }),
          }}
        />
      </Stack>
      <FormHelperText
        sx={{ color: error ? 'red' : 'inherit', paddingLeft: '10px' }}
      >
        {helperText}
      </FormHelperText>
    </Box>
  );
};

export default RoleTextField;
